import type { Me, Section } from '@ft/shared';

/** Gewählter Bereich (bei Personen mit mehreren Bereichen). Wird als Header x-area an den Server geschickt. */
const STORE = 'ft-area';
let areaId: string | null = null;
let areaName = '';
let areaMember = true;

try { areaId = localStorage.getItem(STORE); } catch { /* privater Modus */ }

export const getAreaId = () => areaId;
export const getAreaName = () => areaName;
/** false = Bereich nur über Delivery Head sichtbar: nur ansehen */
export const isAreaMember = () => areaMember;

/** Beim Start: gespeicherte Wahl prüfen, sonst ersten eigenen Bereich nehmen (sonst ersten sichtbaren). */
export function initArea(areas: { id: string; name: string; member?: boolean }[]): void {
  const hit = areas.find((a) => a.id === areaId) ?? areas.find((a) => a.member !== false) ?? areas[0] ?? null;
  areaId = hit?.id ?? null;
  areaName = hit?.name ?? '';
  areaMember = hit?.member !== false;
}

/** Darf die Person im gewählten Bereich ändern? Rolle PM/Admin und dem Bereich zugeordnet. */
export const canEdit = (me: Me) => (me.role === 'admin' || me.role === 'pm') && areaMember;
/** Rechnungen bearbeiten (Zahlungsstatus, Warranty) und Workday-Abgleich: zusätzlich Finance */
export const canEditInvoices = (me: Me) => me.role !== 'reader' && areaMember;

export function switchArea(id: string, to?: string): void {
  try { localStorage.setItem(STORE, id); } catch { /* egal */ }
  // Neu laden, damit alle Ansichten die Daten des anderen Bereichs holen
  if (to) location.assign(to); else location.reload();
}

/**
 * Darf die Person einen Eintrag zu diesen Projekten löschen? Admins und PM/Vertretung eines der Projekte (in eigenen Bereichen)
 * sowie Delivery Heads (in allen Bereichen). Der Server prüft dasselbe; ohne Projekte entscheidet er (angelegt von).
 */
export function canDelete(me: Me, projects: { pm: { id: string } | null; deputy: { id: string } | null }[], hasProjects = projects.length > 0): boolean {
  // Delivery Heads dürfen in jedem sichtbaren Bereich löschen, alle anderen nur in eigenen Bereichen
  if (me.deliveryHead) return true;
  if (!areaMember) return false;
  if (me.role === 'admin') return true;
  if (me.role === 'reader' || me.role === 'finance') return false;
  if (!hasProjects) return true;
  return projects.some((p) => p.pm?.id === me.id || p.deputy?.id === me.id);
}

/** Seite (Pfad) → Freischaltung. Start, Hilfe und Verwaltung hängen nicht daran. */
export const SECTION_OF: Record<string, Section> = { '/bestellungen': 'orders', '/vertraege': 'contracts', '/projekte': 'projects', '/invoicing': 'invoicing', '/forecast': 'forecast', '/offene-punkte': 'issues' };
/** Darf die Person diesen Pfad öffnen? */
export function canSeePath(me: Me, path: string): boolean {
  const base = '/' + (path.split(/[?#]/)[0]!.split('/')[1] ?? '');
  const s = SECTION_OF[base];
  return !s || me.sections.includes(s);
}
